<template>
  <div class="transactionList">
    <div class="transactionList__list__item">
        <div class="transactionList__list__item__left">
          <div class="transactionList__list__item__left__info">
            <p class="small-font title">Campaign Name</p>
            <h3 class="subhead name elipsis">{{campaign.title}}</h3>
            <p class="small-font invoice">Campaign ID {{campaign.id}}</p>
          </div>
          <div class="transactionList__list__item__left__detail">
            <h6 class="small-font">Campaign detail :</h6>
            <div class="transactionList__list__item__left__detail__table">
              <div class="content">
                <p class="small-font">
                  Period
                </p>
                <h6 class="small-font">{{formatDate(campaign.start)}} - {{formatDate(campaign.end)}}</h6>
              </div>
              <div class="content">
                <p class="small-font">
                  Start Date
                </p>
                <h6 class="small-font">{{campaign.period}} Months </h6>
              </div>
              <div class="content">
                <p class="small-font">
                  Total items
                </p>
                <h6 class="small-font">{{campaign.totalBusCount}} Items</h6>
              </div>
            </div>
            <!-- <div class="action">
              <i class="icon-chevrondown" v-if="isMobile" @click.stop="toggle"></i>
            </div> -->
          </div>
        </div>
        <div class="transactionList__list__item__middle">
          <div class="transactionList__list__item__middle__status">
            <p class="small-font title">
              Campaign Status :
            </p>
            <div class="content">
              <ul>
                <template v-if="orderStatus == 0">
                  <li class="small-font active">Lead</li>
                  <li class="small-font">Verifying</li>
                  <li class="small-font">Designing</li>
                  <li class="small-font">Design Approval</li>
                  <li class="small-font">Printing</li>
                  <li class="small-font">Print Approval</li>
                  <li class="small-font">Wrapping </li>
                  <li class="small-font">Done</li>
                </template>
                <template v-if="orderStatus == 1">
                  <li class="small-font active">Lead</li>
                  <li class="small-font active">Verifying</li>
                  <li class="small-font">Designing</li>
                  <li class="small-font">Design Approval</li>
                  <li class="small-font">Printing</li>
                  <li class="small-font">Print Approval</li>
                  <li class="small-font">Wrapping </li>
                  <li class="small-font">Done</li>
                </template>
                <template v-if="orderStatus == 2">
                  <li class="small-font active">Lead</li>
                  <li class="small-font active">Verifying</li>
                  <li class="small-font active">Designing</li>
                  <li class="small-font">Design Approval</li>
                  <li class="small-font">Printing</li>
                  <li class="small-font">Print Approval</li>
                  <li class="small-font">Wrapping </li>
                  <li class="small-font">Done</li>
                </template>
                <template v-if="orderStatus == 3">
                  <li class="small-font active">Lead</li>
                  <li class="small-font active">Verifying</li>
                  <li class="small-font active">Designing</li>
                  <li class="small-font active">Design Approval</li>
                  <li class="small-font">Printing</li>
                  <li class="small-font">Print Approval</li>
                  <li class="small-font">Wrapping </li>
                  <li class="small-font">Done</li>
                </template>
                <template v-if="orderStatus == 4">
                  <li class="small-font active">Lead</li>
                  <li class="small-font active">Verifying</li>
                  <li class="small-font active">Designing</li>
                  <li class="small-font active">Design Approval</li>
                  <li class="small-font active">Printing</li>
                  <li class="small-font">Print Approval</li>
                  <li class="small-font">Wrapping </li>
                  <li class="small-font">Done</li>
                </template>
                <template v-if="orderStatus == 5">
                  <li class="small-font active">Lead</li>
                  <li class="small-font active">Verifying</li>
                  <li class="small-font active">Designing</li>
                  <li class="small-font active">Design Approval</li>
                  <li class="small-font active">Printing</li>
                  <li class="small-font active">Print Approval</li>
                  <li class="small-font">Wrapping </li>
                  <li class="small-font">Done</li>
                </template>
                <template v-if="orderStatus == 6">
                  <li class="small-font active">Lead</li>
                  <li class="small-font active">Verifying</li>
                  <li class="small-font active">Designing</li>
                  <li class="small-font active">Design Approval</li>
                  <li class="small-font active">Printing</li>
                  <li class="small-font active">Print Approval</li>
                  <li class="small-font active">Wrapping </li>
                  <li class="small-font">Done</li>
                </template>
                <template v-if="orderStatus == 7">
                  <li class="small-font active">Lead</li>
                  <li class="small-font active">Verifying</li>
                  <li class="small-font active">Designing</li>
                  <li class="small-font active">Design Approval</li>
                  <li class="small-font active">Printing</li>
                  <li class="small-font active">Print Approval</li>
                  <li class="small-font active">Wrapping </li>
                  <li class="small-font active">Done</li>
                </template>
              </ul>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import { formatShortDate } from '@/lib/util'

export default {
  name: 'adx-transaction-list',
  components: {
  },
  props: {
    campaign: {
      required: false
    },
    orderStatus: {
      required: false
    },
  },
  data() {
    return {
      isOpen: window.innerWidth < 769 ? true : false
    }
  },
  computed: {
    isMobile() {
      return window.innerWidth < 769 ? false : true
    }
  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {
    
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    toggle() {
      this.isOpen = !this.isOpen;
    },
    formatDate(date) {
      return formatShortDate(date)
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>